import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { selectSelectedDevice } from 'entities/device/lib';
import { usePartial } from 'shared/hooks/utils';
import { createIssue } from 'shared/support.request/model/actions';
export const useCreateSupportIssue = (ba_name) => {
    const { email, fullname, username } = useAppSelector((state) => state.account);
    const device = useAppSelector(selectSelectedDevice);
    const issue = {
        email,
        name: fullname ?? username,
        title: 'Автоматический запрос на обновление АЦЩ для протокола BSB',
        description: `Требуется обновить АЦЩ ${ba_name} для протокола BSB. Прибор ${device?.name} (${device?.serial})`,
    };
    return usePartial(useAction(createIssue), issue);
};
